import get from 'transmute/get';
import { AUDIT, TYPE, STATUS } from '../constants/keyPaths';
export const getAudit = get(AUDIT);
export const getType = get(TYPE);
export const getStatus = get(STATUS);